import React from "react";

function Page(props) {

	return (
		<label>nuevo encuesta</label>
	);
}

export default Page;